<template>
  <div class="detail-wrapper">
    <el-dialog
      v-bind="dialogProps"
       width="50%"
       top="30px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-collapse v-model="activeNames" v-loading="loading">
        <el-collapse-item title="合同回款" name="1">
          <info-item :title="['客户名称', '回款金额']" :data="[detailInfo.customerName, detailInfo.refundAmount]"></info-item>
          <info-item :title="['回款日期', '业务员']" :data="[detailInfo.refundDate, detailInfo.salesmanName]"></info-item>
          <info-item :title="['团队']" :data="[detailInfo.teamName]"></info-item>
        </el-collapse-item>

        <el-collapse-item title="详细信息" name="2">
          <info-item :title="['回款类型', '回款期数']" :data="[detailInfo.refundType, detailInfo.refundInstallment]"></info-item>
          <info-item :title="['合同编号', '合同金额(元)']" :data="[detailInfo.contractNo, detailInfo.contractAmount]"></info-item>
          <info-item :title="['客户打款银行', '客户打款账号']" :data="[detailInfo.customerPayBank, detailInfo.customerPayAccount]"></info-item>
          <info-item :title="['我方收款公司', '我方收款银行']" :data="[detailInfo.myReceivableCompany, detailInfo.myReceivableBank]"></info-item>
          <info-item :title="['我方收款账号', '状态']" :data="[detailInfo.myReceivableAccount, detailInfo.examineStatus]"></info-item>
          <info-item :title="['最小预算单元', '一级结算部门']" :data="[detailInfo.minimumBudgetUnit, detailInfo.firstAccountDept]"></info-item>
          <info-item :title="['业务结算部门', '备注']" :data="[detailInfo.businessAccountDept, detailInfo.remark]"></info-item>
        </el-collapse-item>

        <el-collapse-item title="开票信息" name="3">
          <info-item :title="['发票编号', '开票金额']" :data="[detailInfo.invoiceNo, detailInfo.invoiceAmount]"></info-item>
          <info-item :title="['开票日期', '开票备注']" :data="[detailInfo.invoiceDate, detailInfo.invoiceRemark]"></info-item>
        </el-collapse-item>

         <el-collapse-item title="附件信息" name="4">
          <el-table
            :data="detailInfo.fileList"
          >
            <el-table-column
              prop="fileName"
              align="center"
              label="附件名称"
            />
            <el-table-column
              prop="fileSize"
              align="center"
              label="附件大小(MB)"
              :formatter="handleFormatterSize"
            />
            <el-table-column
              align="center"
              label="操作"
            >
              <template slot-scope="{row}">
                <el-button
                  type="text"
                  size="small"
                  @click="handleDownload(row)"
                >下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>

         <el-collapse-item title="系统信息" name="5">
          <info-item :title="['创建人', '创建时间']" :data="[detailInfo.creator, detailInfo.createTime]"></info-item>
          <info-item :title="['更新人', '更新时间']" :data="[detailInfo.modifier, detailInfo.updateTime]"></info-item>
        </el-collapse-item>
      </el-collapse>
    </el-dialog>
  </div>
</template>

<script>
import InfoItem from '~component/base/detail-info-item.vue';
import services from '@/services/api/compact/'

export default {
  components: {
    InfoItem,
  },
  data() {
    return {
      loading: false,
      dialogProps: {
        visible: false,
        title: '回款详情',
      },
      activeNames: ['1', '2', '3'],
      detailInfo: {},
    };
  },
  mounted() {},
  methods: {
    async handleOpenDetail(id) {
      this.dialogProps.visible = true
      try {
        this.loading = true
        const { data } = await services.apiGetPaybackDetail({ id })
        this.detailInfo = data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    handleClose() {
      this.dialogProps.visible = false
    },
    handleDownload(row) {
      window.location.href = row.fileUrl
    },
    handleFormatterSize(row) {
      return (row.fileSize / 1024 / 1024).toFixed(2)
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-collapse-item__content {
  padding-bottom: 0;
}
/deep/ .el-dialog__body {
  padding-top: 10px;
}
</style>
